import IState from '../state';
import { createSelector } from 'reselect';

export const getSiteRolesSelector= createSelector((state:IState)=> state.roles.siteRoles,(siteRoles)=>siteRoles);